import {Exclude, Expose, instanceToPlain, plainToInstance, Transform, Type} from "class-transformer";
import * as t from "io-ts";
import {validateJSON, validateJSONNow} from "../web/validation";
import {CargoSubtype, toCargoSubtype} from "./cargo-subtype";
import {getDatabaseCodeTransformer} from "./transfomers/transformers";
import {Default} from "../util/decorators";
import {TimeGroup, toTimeGroup} from "./time-group";
import {
    AllocatableLoadInventorySnapshotEntryArrayValidator,
    AllocatableLoadInventorySnapshotEntryEntity
} from "./allocatable-load-inventory-snapshot-entry";

export const AllocatableLoadInventorySnapshotValidator = t.intersection([
    t.type({
        objectId: t.string,
        cargoSubtype: t.string,
        objectType: t.string,
        timeGroup: t.string,
        regionId: t.string,
    }),
    t.partial({
        objectName: t.string,
        volumeUnitOfMeasure: t.string,
        entries: AllocatableLoadInventorySnapshotEntryArrayValidator,
    }),
]);

export const AllocatableLoadInventorySnapshotArrayValidator = t.array(AllocatableLoadInventorySnapshotValidator);

export type AllocatableLoadInventorySnapshot = t.TypeOf<typeof AllocatableLoadInventorySnapshotValidator>;
export type AllocatableLoadInventorySnapshotArray = t.TypeOf<typeof AllocatableLoadInventorySnapshotArrayValidator>;

@Exclude()
export class AllocatableLoadInventorySnapshotEntity {
    @Expose()
    objectId!: string;

    @Expose()
    objectName?: string;

    @Expose()
    objectType!: string;

    @Expose()
    regionId!: string;

    @Expose()
    @Transform(getDatabaseCodeTransformer(toCargoSubtype))
    cargoSubtype!: CargoSubtype

    @Expose()
    volumeUnitOfMeasure?: string;

    @Expose()
    @Transform(getDatabaseCodeTransformer(toTimeGroup))
    timeGroup!: TimeGroup

    @Expose()
    @Type(() => AllocatableLoadInventorySnapshotEntryEntity)
    @Default([])
    entries: AllocatableLoadInventorySnapshotEntryEntity[] = [];

    /**
     * Constructor for AllocatableLoadInventorySnapshotEntity.
     * @hideconstructor
     */
    constructor() {
        // Empty constructor for 'class-transformer'
    }

    static from(containerAllocatableLoadInventoryGroup: AllocatableLoadInventorySnapshot): AllocatableLoadInventorySnapshotEntity {
        return plainToInstance(
            AllocatableLoadInventorySnapshotEntity,
            containerAllocatableLoadInventoryGroup,
            {
                excludeExtraneousValues: true,
            }
        );
    }

    loadTypeValue(): Promise<AllocatableLoadInventorySnapshot> {
        const object = instanceToPlain(this, {
            excludeExtraneousValues: true,
        });
        return validateJSON(AllocatableLoadInventorySnapshotValidator, object);
    }

    asTypeValue(): AllocatableLoadInventorySnapshot {
        const object = instanceToPlain(this, {
            excludeExtraneousValues: true,
        });
        return validateJSONNow(AllocatableLoadInventorySnapshotValidator, object);
    }
}
